import React, { Component } from 'react';
import {
  createStyles,
  Theme,
  WithStyles,
  Card,
  CardContent,
  withStyles,
  Typography,
  Grid,
} from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  fontBold: {
    fontWeight: 400,
    fontSize: '2.8em',
  },
  fontline: {
    display: 'inline',
  },
  bdShadow: {
    MozBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
    WebkitBoxShadow: '0px 0px 10px rgba(0, 0, 0, 0.168337)',
  },
  mb1x: {
    marginBottom: theme.spacing.unit * 2,
  },
  mr1x: {
    marginRight: theme.spacing.unit,
  },
  cardContentRoot: {
    position: 'relative',
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    //paddingBottom: theme.spacing.unit * 2,
    '& ul': {
      listStyle: 'none',
      display: 'flex',
      padding: 0,
      margin: 0,
    }
  },
  toggleDiv: {
    background: 'rgba(233, 239, 244, 0.48)',
    borderRadius: theme.shape.borderRadius,
  },
  toggle: {


    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },
    '& .active': {
      background: '#fff',
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
    '&:hover': {
      cursor: 'pointer',
    }
  },
  breadcrumb: {
    '& li': {
      ...theme.typography.body1,
      marginRight: theme.spacing.unit,
      borderRadius: theme.shape.borderRadius,

    },


  },

  dropdown: {
    float: "right",
    border: 'none',
    background: 'rgba(233, 239, 244, 0.48)',
    fontSize: 14,
    color: '#323C47',
    padding: theme.spacing.unit,
    borderRadius: theme.shape.borderRadius,
  },
  dropdown1: {
    height: 36,

  },
  dropdown2: {
    height: 36,

  },
});

interface DashboardStatsSyllabusProps extends WithStyles<typeof styles> {

}

const DashboardStatsSyllabus = (props: any) => {

  const { classes } = props;

  return (
    <>
      <Grid container spacing={16}>
        <Grid item xs>
          <Card className={classes.bdShadow}>
            <CardContent className={classes.cardContentRoot}>
              <Typography variant="h2" className={classes.fontBold}>
                4000
          </Typography>
              <Typography>
                Questions
          </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs>
          <Card className={classes.bdShadow}>
            <CardContent>
              <Typography variant="h2" className={classes.fontBold}>
                1540
          </Typography>
              <Typography>
                Study Notes
          </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs>
          <Card className={classes.bdShadow}>
            <CardContent>
              <Typography variant="h2" className={classes.fontBold}>
                2345
          </Typography>
              <Typography>
                Videos
          </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={16}>
        <Grid item xs={4}>
          <Card className={classes.bdShadow}>
            <CardContent>
              <Typography variant="h2" className={classes.fontBold}>
                365
      </Typography>
              <Typography>
                Sample Questions
        </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card className={classes.bdShadow}>
            <CardContent>
              <Typography variant="h2" className={classes.fontBold}>
                645
        </Typography>
              <Typography>
                Formula Sheets
        </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

export default withStyles(styles)(DashboardStatsSyllabus);